module.exports = __webpack_public_path__ + "img/menu-yaogan-active.38d00691.svg";